import { render, staticRenderFns } from "./wisdomBuy.vue?vue&type=template&id=67256bb9"
import script from "./wisdomBuy.vue?vue&type=script&lang=js"
export * from "./wisdomBuy.vue?vue&type=script&lang=js"
import style0 from "./wisdomBuy.vue?vue&type=style&index=0&id=67256bb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports